import React from 'react';
import { Button } from '@blueprintjs/core';
import { MenuItem } from "@blueprintjs/core";
import { Select } from "@blueprintjs/select";
import styled from 'styled-components';
import theme from '../../theme';
import { itemPredicate, itemRenderer, itemListRenderer } from "./select";

const Container = styled.div`
  margin-top: 10px;
`;

class ItemSelector extends React.Component {

  render() {

    const {item, items, onItemSelect} = this.props;
    const text = item.name;

    return (
      <Container>
        <Select
          items={items}
          itemPredicate={itemPredicate}
          itemRenderer={itemRenderer}
          itemListRenderer={itemListRenderer}
          noResults={<MenuItem disabled={true} text="No results."/>}
          onItemSelect={onItemSelect}
          popoverProps={{
            minimal: true,
            popoverClassName: 'select-popover'
          }}
        >
          <Button
            className="button-align-left"
            style={{width: theme.selectPopoverWidth}}
            rightIcon="caret-down"
            text={item ? text : "(No selection)"}
          />
        </Select>
      </Container>
    );
  }
}

export default ItemSelector;



// WEBPACK FOOTER //
// ./src/containers/ItemSelector/index.js